export const ADMIN_NOTIFICATIONS_REFRESH_EVENT = 'admin-notifications:refresh';

/** Ask header stack and Action Center inbox to reload active notifications. */
export function requestAdminNotificationsRefresh(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(ADMIN_NOTIFICATIONS_REFRESH_EVENT));
}

/**
 * Reload notifications after a mutation that may have cleared/republished findings.
 * Immediate + short delayed pass covers header 60s poll lag when the server
 * finishes reconcile slightly after the save response (or for fire-and-forget paths).
 */
export function requestAdminNotificationsRefreshSoon(delayMs = 750): void {
  requestAdminNotificationsRefresh();
  if (typeof window === 'undefined') return;
  window.setTimeout(() => requestAdminNotificationsRefresh(), delayMs);
}
